import Img from '@core/components/Img';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const OuterBox = styled(Box)`
  height: 100vh;
  left: 0;
  max-height: 100vh;
  overflow: hidden;
  position: relative;
  top: 0;
  width: 100%;
`;

export const CloseDialogButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  z-index: 1;
`;

export const StaticImageBox = styled(Box)`
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const StaticImage = styled(Img)`
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

export const ScrollableContentBox = styled(Box)`
  height: 100%;
  left: 0;
  overflow-y: auto;
  position: absolute;
  top: 0;
  width: 100%;
`;
